import React from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SuggestionItemWrapper = styled.div.withConfig({
  displayName: "suggestion-itemcomponent__SuggestionItemWrapper",
  componentId: "sc-ch4nij-0"
})(["display:flex;align-items:flex-start;gap:12px;padding:16px;border:1px solid #e4e9ec;border-radius:8px;cursor:pointer;transition:all 0.2s ease;background-color:#fff;&:hover{border-color:#195aff;box-shadow:0 2px 8px rgba(25,90,255,0.1);}"]);
var IconWrapper = styled.div.withConfig({
  displayName: "suggestion-itemcomponent__IconWrapper",
  componentId: "sc-ch4nij-1"
})(["display:flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:8px;background-color:#e2f0ff;color:#195aff;flex-shrink:0;"]);
var ContentWrapper = styled.div.withConfig({
  displayName: "suggestion-itemcomponent__ContentWrapper",
  componentId: "sc-ch4nij-2"
})(["flex:1;min-width:0;"]);
var Title = styled.div.withConfig({
  displayName: "suggestion-itemcomponent__Title",
  componentId: "sc-ch4nij-3"
})(["font-size:14px;font-weight:600;color:#2d3748;margin-bottom:4px;line-height:1.4;"]);
var Description = styled.div.withConfig({
  displayName: "suggestion-itemcomponent__Description",
  componentId: "sc-ch4nij-4"
})(["font-size:13px;color:#718096;line-height:1.4;"]);
export var SuggestionItem = function SuggestionItem(_ref) {
  var title = _ref.title,
      description = _ref.description,
      icon = _ref.icon,
      promptText = _ref.promptText,
      onClick = _ref.onClick;

  var handleClick = function handleClick() {
    onClick({
      title: title,
      description: description,
      icon: icon,
      promptText: promptText
    });
  };

  return /*#__PURE__*/_jsxs(SuggestionItemWrapper, {
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx(IconWrapper, {
      children: icon
    }), /*#__PURE__*/_jsxs(ContentWrapper, {
      children: [/*#__PURE__*/_jsx(Title, {
        children: title
      }), /*#__PURE__*/_jsx(Description, {
        children: description
      })]
    })]
  });
};